import { AutoComplete, AutoCompleteProps } from "antd";
import { Control, Controller } from "react-hook-form";

interface IProps {
  name: string;
  label: string;
  placeholder: string;
  control: Control<any, any>;
  options: AutoCompleteProps["options"];
  icon: string;
  isActive: boolean;
  onSelect: (data: string, option?: any) => void;
  onSearch?: (value: string) => void;
  handleToggleLocation: () => void;
  disabled?: boolean;
  loading?: boolean;
}

export default function LabeledAutoComplete({
  name,
  label,
  placeholder,
  control,
  options,
  icon,
  isActive,
  handleToggleLocation,
  onSelect,
  onSearch,
  disabled,
  loading,
}: IProps) {
  // Debug logging
  if (name === "pickup_location" || name === "drop_off_location") {
    console.log(`📋 ${name} options:`, options, "count:", options?.length);
  }

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={""}
      render={({ field, fieldState: { error } }) => (
        <div className="w-full">
          <label
            htmlFor={name}
            className="pl-1"
            style={{ color: "rgba(0,0,0,.7)", fontSize: ".85rem" }}
          >
            {label}
          </label>
          <div className="w-full flex items-center justify-between gap-x-1">
            <AutoComplete
              id={name}
              options={options}
              onChange={(e) => {
                field.onChange(e);
              }}
              onSearch={onSearch}
              filterOption={false}
              allowClear
              value={field.value}
              onSelect={onSelect}
              className="h-auto w-full pt-2 outline-none"
              ref={field.ref}
              disabled={disabled || field.disabled}
              onBlur={field.onBlur}
              placeholder={placeholder}
              status={error ? "error" : undefined}
              notFoundContent={loading ? "Searching..." : "No results found"}
            />
            <button
              type="button"
              onClick={handleToggleLocation}
              disabled={disabled}
              className={`h-full rounded-md px-1 py-1.5 ${isActive ? "bg-orange-300" : ""
                } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              <img src={icon} alt="pin" className="w-10 h-8" />
            </button>
          </div>
          <span className="text-xs text-red-500">{error?.message}</span>
        </div>
      )}
    />
  );
}
